/* Preview gift: local persistent timers and native Shopify discount codes.
   Timers govern this page/cart only; an already opened checkout is not revoked. */
(() => {
  'use strict';
  const configEl = document.getElementById('sfhg-config');
  if (!configEl || window.SofthourHalloween) return;
  const cfg = JSON.parse(configEl.textContent);
  const priceTest = window.SofthourPriceAB;
  if (priceTest?.renderedProductId) cfg.productId = priceTest.renderedProductId;
  const basePrice = Number(cfg.basePrice); // Native Shopify price, shared by both presentations.
  if (!Number.isInteger(basePrice) || basePrice <= 500) return;
  const candyShipping = 999; // Existing US tier for a $69.99 subtotal.
  const fleeceProduct = pid => ['10195007799351','15417171902519'].includes(String(pid));
  document.querySelectorAll('[data-sfhg-reward-price]').forEach(el => {el.textContent = '$' + ((basePrice - 500) / 100).toFixed(2);});
  const KEY = cfg.storageKey;
  if (typeof KEY !== 'string' || !KEY.startsWith('sf-seasonal:softhour-fall-20261101-v1:') || !['A','B'].includes(cfg.arm)) return;
  const fall = cfg.markFall === true;
  const sourceId = 'sf-seasonal-gift';
  const resetParameter = cfg.resetParameter === 'fall' ? 'fall' : 'candy';
  const expiredFallback = fall ? 'Your fall cart offer has ended. The Fall Clearance Sale is still available.' : 'Your Halloween cart offer has ended. The Halloween Sale is still available.';
  const rememberContext = () => {try {sessionStorage.setItem(cfg.contextKey,JSON.stringify({arm:cfg.arm,qa:!!cfg.qa}));} catch (_) {}};
  const text = (key, fallback) => typeof cfg.text?.[key] === 'string' ? cfg.text[key] : fallback;
  const money = n => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(n / 100);
  const root = window.Shopify?.routes?.root || '/';
  const readSaved = value => {
    try {
      const d = JSON.parse(value || 'null');
      return d?.version === 2 && ['claim','cart','expired'].includes(d.state) &&
        Number.isFinite(d.addDeadline) && (d.cartDeadline === null || Number.isFinite(d.cartDeadline)) ? d : null;
    } catch (_) { return null; }
  };
  let saved = null;
  try { saved = readSaved(localStorage.getItem(KEY)); } catch (_) {}
  const inPage = !!document.querySelector('product-form-component[data-product-id="'+cfg.productId+'"]') && (cfg.page === 'mama-fleece' || cfg.productPage === true);
  if (cfg.currency !== 'USD' || (!inPage && !saved) || !cfg.code5 || !cfg.code25) return;
  const launcher = document.querySelector('[data-sfhg-launcher]'), dialog = document.querySelector('[data-sfhg-dialog]');
  const resetParameters = fall ? [resetParameter,'candy'] : [resetParameter];
  const urlReset = cfg.previewReset && resetParameters.some(key => new URLSearchParams(location.search).get(key) === 'reset');
  let launcherReady = false;
  let nativeApplied = false, confirmedCheckoutCode = null, uiUnavailable = false, cartNeedsRecovery = false, expiredCleaned = false;
  let syncPromise = null, preparePromise = null, resetPromise = null, queue = false, resetting = false, cartDelay;
  let refreshCartSections = false, confirmedCart = null, nextExpiryRetryAt = 0;
  let operationCount = 0, operationTail = Promise.resolve(), deferredSyncPromise = null;
  const operations = new WeakSet();
  function beginOperation(pid) {
    if (!fleeceProduct(pid)) return null;
    const ready = operationTail;
    let release;
    const completion = new Promise(resolve => { release = resolve; });
    operationTail = ready.then(() => completion);
    const token = {ready,release};operations.add(token);operationCount++;
    return token;
  }
  function endOperation(token) {
    if (!token || !operations.has(token)) return;
    operations.delete(token);operationCount--;token.release();
  }
  async function waitForOperations() {
    while (operationCount) await operationTail;
  }
  const rememberCart = cart => {
    if (cart && Array.isArray(cart.items) && Number.isFinite(cart.total_price)) confirmedCart = cart;
    return cart;
  };
  let lastSyncError = null, lastCartQuantity = null, syncAttempt = 0;
  function noteGiftDiagnostics() {
    if (!cfg.qa) return;
    document.documentElement.dataset.shGiftDiagnostics = JSON.stringify({arm:cfg.arm,state:saved?.state || 'unclaimed',
      deadlineRemainingSeconds:Math.max(0,Math.ceil((deadline()-Date.now())/1000)),nativeApplied,uiUnavailable,
      syncing:!!syncPromise,preparing:!!preparePromise,cartNeedsRecovery,syncAttempt,lastCartQuantity,lastSyncError});
  }
  const write = () => {try {localStorage.setItem(KEY, JSON.stringify(saved));} catch (_) {}};
  const deadline = () => Number(saved?.cartDeadline ?? saved?.addDeadline ?? 0);
  const eligible = () => !!saved && ['claim','cart'].includes(saved.state) && deadline() > Date.now();
  const active = () => eligible() && !uiUnavailable;
  const clock = () => {
    const s = Math.max(0, Math.ceil((deadline() - Date.now()) / 1000));
    return String(Math.floor(s / 60)).padStart(2,'0') + ':' + String(s % 60).padStart(2,'0');
  };
  function expire() {
    if (saved && saved.state !== 'expired' && deadline() <= Date.now()) {
      saved.state = 'expired'; nextExpiryRetryAt = 0; write(); return true;
    }
    return false;
  }
  function notice(text) {
    let el = document.querySelector('.sfhg-status');
    if (!el) {el = document.createElement('div');el.className = 'sfhg-status';el.setAttribute('role','status');document.body.append(el);}
    el.textContent = text;clearTimeout(el._hide);el._hide = setTimeout(() => el.remove(),6500);
  }
  async function jsonFetch(url, options = {}) {
    const r = await fetch(url,{...options,signal:options.signal || AbortSignal.timeout(3500),headers:{Accept:'application/json',...(options.body ? {'Content-Type':'application/json'} : {}),...options.headers}});
    const d = await r.json();if (!r.ok) throw Error('cart_unavailable');return d;
  }
  const cartGet = signal => jsonFetch(root + 'cart.js',{signal}).then(rememberCart);
  const shape = (cart,add = 0,flash = false) => ({
    quantity:cart.items.filter(x => fleeceProduct(x.product_id)).reduce((n,x) => n + x.quantity,0) + add,
    flashUpsell:flash || cart.items.some(x => fleeceProduct(x.product_id) && x.properties?._cv_flash),
  });
  const codesOf = cart => Array.isArray(cart.discount_codes) ? cart.discount_codes.map(x => x.code).filter(Boolean) :
    [...new Set([...(cart.cart_level_discount_applications || []),...cart.items.flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))]
      .filter(x => x?.type === 'discount_code').map(x => x.title).filter(Boolean))];
  const sameCode = (a,b) => String(a).toUpperCase() === String(b).toUpperCase();
  const ownCode = code => sameCode(code,cfg.code5) || sameCode(code,cfg.code25);
  const flashCode = code => sameCode(code,'FLASH-FLEECE20');
  const selection = s => s.quantity >= 2 && s.flashUpsell ? {code:cfg.code25,amount:2500} : {code:cfg.code5,amount:500};
  const sections = () => [...new Set([...document.querySelectorAll('cart-items-component')].map(x => x.dataset.sectionId).filter(Boolean))];
  const discountTotal = (cart,match) => cart.items.filter(i => fleeceProduct(i.product_id)).reduce((sum,i) => sum +
    (i.line_level_discount_allocations || []).filter(a => match(a.discount_application?.title || '')).reduce((n,a) => n + Number(a.amount || 0),0),0);
  const applied = (cart,amount) => discountTotal(cart,t => ownCode(t) || (cfg.title5 && sameCode(t,cfg.title5)) || (cfg.title25 && sameCode(t,cfg.title25))) === amount;
  function dispatchCart(cart) {
    const event = new Event('cart:update',{bubbles:true});event.detail = {resource:cart,sourceId,data:{sections:cart.sections}};document.dispatchEvent(event);
  }
  async function setCode(cart,code,signal,refreshSections = false,renderSections = true) {
    let codes = codesOf(cart).filter(c => !ownCode(c));
    // Replace only the other seasonal family, only after an explicit claim.
    if (code) codes = codes.filter(c => !(cfg.otherCodes || []).some(other => sameCode(c,other)));
    if (code) {codes = codes.filter(c => !flashCode(c));codes.push(code);}
    else {const s = shape(cart);if (s.quantity >= 2 && s.flashUpsell && !codes.some(flashCode)) codes.push('FLASH-FLEECE20');}
    const selected = [...new Set(codes)], normalize = list => list.map(c => c.toUpperCase()).sort().join(',');
    if (!refreshSections && normalize(selected) === normalize(codesOf(cart))) return rememberCart(cart);
    const result = await jsonFetch(root + 'cart/update.js',{method:'POST',signal,body:JSON.stringify({discount:selected.join(','),...(renderSections ? {sections:sections(),sections_url:location.pathname + location.search} : {})})});
    rememberCart(result);if (renderSections) dispatchCart(result);return result;
  }
  async function restoreNativeOffer() {
    const signal = AbortSignal.timeout(3500);
    const refresh = refreshCartSections;refreshCartSections = false;
    let cart = await cartGet(signal);cart = await setCode(cart,null,signal,refresh);
    const s = shape(cart);
    if (s.quantity >= 2 && s.flashUpsell && discountTotal(cart,t => /flash/i.test(t)) < 2000) throw Error('native_upsell_unconfirmed');
    nativeApplied = false;confirmedCheckoutCode = null;uiUnavailable = true;render();return cart;
  }
  function restorePrice() {
    document.querySelectorAll('[data-sfhg-base]').forEach(p => {
      const base = Number(p.dataset.sfhgBase);p.querySelectorAll('.price-item--sale').forEach(x => x.textContent = money(base) + ' USD');
      p.classList.remove('sfhg-active-price');p.querySelector('.sfhg-price-note')?.remove();p.querySelector('.sfhg-gift-badge')?.remove();
      const s = p.querySelector('.sf-offer-badge--saving');if (s) s.textContent = 'SAVE ' + money(Number(p.dataset.sfhgCompare) - base);
    });
  }
  function renderCartNote() {
    if (!active() || saved.state !== 'cart' || !nativeApplied) {
      document.querySelectorAll('.sfhg-cart-note').forEach(x => x.remove());return;
    }
    document.querySelectorAll('.cart-drawer__summary,.cart__summary').forEach(p => {
      if (!p.querySelector('.sfhg-cart-note')) {
        const n = document.createElement('div');n.className = 'sfhg-cart-note';if(fall)n.setAttribute('data-sf-fall-gift','');
        n.innerHTML = '<p><b></b><small></small></p><strong data-sfhg-clock></strong>';
        n.querySelector('b').textContent = text('cart_title',fall ? 'Your fall treat is secured' : 'Your Halloween treat is secured');
        n.querySelector('small').textContent = text('cart_subtitle','Use your treat before it expires in…');
        const c = p.querySelector('[name="checkout"]');if (c) c.parentElement.insertBefore(n,c);else p.append(n);
      }
    });
  }
  function updateClocks() {
    const value = clock();
    document.querySelectorAll('[data-sfhg-clock]').forEach(x => {if (x.textContent !== value) x.textContent = value;});
    noteGiftDiagnostics();
  }
  function render() {
    noteGiftDiagnostics();
    // An unexpired treat can be reopened/retried without starting a new deadline.
    // A transient native error must not hide its launcher. Expired treats stay expired.
    if (launcher) launcher.hidden = !launcherReady || !inPage || resetting || (!!saved && !eligible());
    const showOffer = active() && (saved.state !== 'cart' || nativeApplied);
    if (!showOffer) {
      restorePrice();renderCartNote();
      if (dialog?.open) {dialog.querySelector('[data-sfhg-success]').hidden = true;const e = dialog.querySelector('[data-sfhg-error]');e.hidden = false;
        e.textContent = saved?.state === 'expired' ? text('expired_text',expiredFallback) : 'Your gift could not be confirmed. Please check the price in your bag.';}
      return;
    }
    document.querySelectorAll('[data-sfhg-base]').forEach(p => {
      const base = Number(p.dataset.sfhgBase);if (base !== basePrice) return;
      if(fall)p.setAttribute('data-sf-fall-gift','');p.classList.add('sfhg-active-price');p.querySelectorAll('.price-item--sale').forEach(x => x.textContent = money(base - 500) + ' USD');
      let note = p.querySelector('.sfhg-price-note');if (!note) {note = document.createElement('div');note.className = 'sfhg-price-note';if(fall)note.setAttribute('data-sf-fall-gift','');note.innerHTML = '<span><span data-sfhg-price-title></span><small></small></span><strong data-sfhg-clock></strong>';
        note.querySelector('[data-sfhg-price-title]').textContent = text('price_title',fall ? 'Your $5 fall gift' : 'Your $5 Halloween gift');p.append(note);}
      note.querySelector('small').textContent = saved.state === 'cart' ? text('after_add','Complete your order in…') : text('before_add','Add to your bag while this offer is on screen');
      if (cfg.shippingNote && cfg.country === 'US') note.querySelector('small').textContent += ' · One fleece: ' + money(candyShipping) + ' US shipping, ' + money(basePrice - 500 + candyShipping) + ' before tax';
      if (!p.querySelector('.sfhg-gift-badge')) {const b = document.createElement('span');b.className = 'sfhg-gift-badge';if(fall)b.setAttribute('data-sf-fall-gift','');b.textContent = cfg.giftBadge || (fall ? 'EXTRA $5 FALL GIFT' : '🎃 EXTRA $5 GIFT');p.querySelector('.sf-offer-badges')?.append(b);}
      const s = p.querySelector('.sf-offer-badge--saving');if (s) s.textContent = 'SAVE ' + money(Number(p.dataset.sfhgCompare) - base + 500);
    });
    renderCartNote();updateClocks();
  }
  function tick() {
    // No countdown or expiry work exists before a claim or after cleanup.
    if (resetting || !saved || (saved.state === 'expired' && expiredCleaned)) return;
    if (expire()) {render();notice(text('expired_text',expiredFallback));}
    // Native section rendering may complete after our cart:update handler and
    // erase the inserted note. Repair the DOM, never the persisted deadline.
    renderCartNote();updateClocks();
    if (saved.state === 'expired' && !expiredCleaned && !syncPromise && Date.now() >= nextExpiryRetryAt) {
      // Automatic cleanup retries must not hammer Shopify after a fast failure.
      // Explicit cart/checkout/visibility/storage actions still reconcile now.
      nextExpiryRetryAt = Date.now() + 30000;
      sync().catch(() => {});
    }
  }
  async function sync(refreshSections = false,observedCart = null) {
    if (resetting || !saved) return false;
    refreshCartSections = refreshCartSections || refreshSections;
    // A prepared $25 code must survive until the pending second item commits.
    // Defer background reconciliation outside syncPromise so prepare cannot
    // wait on a sync that is itself waiting for this operation to finish.
    if (operationCount) {
      if (!deferredSyncPromise) deferredSyncPromise = waitForOperations().then(() => {
        deferredSyncPromise = null;return sync();
      });
      return deferredSyncPromise;
    }
    if (syncPromise) {queue = true;return syncPromise;}
    syncPromise = (async () => {
      let safe = false;
      do {
        queue = false;safe = false;
        try {
          if (preparePromise) await preparePromise;
          expire();
          if (!eligible()) {await restoreNativeOffer();expiredCleaned = true;safe = true;continue;}
          let cart = observedCart || await cartGet(), s, offer;observedCart = null;rememberCart(cart);
          const refresh = refreshCartSections;refreshCartSections = false;
          for (let attempt = 0; attempt < 2; attempt++) {
            s = shape(cart);offer = selection(s);syncAttempt = attempt + 1;lastCartQuantity = s.quantity;
            cart = await setCode(cart,offer.code,undefined,attempt === 0 && refresh,s.quantity > 0 || refresh);
            nativeApplied = applied(cart,offer.amount);
            if (nativeApplied || s.quantity === 0 || attempt === 1) break;
            // A removal can commit between our read and discount write. Re-read
            // once and select $5/$25 from the actual quantity before fallback.
            cart = await cartGet();
          }
          uiUnavailable = false;
          if (nativeApplied) lastSyncError = null;
          else if (s.quantity > 0) lastSyncError = {name:'GiftNotApplied',message:'Native discount unconfirmed after two quantity checks'};
          confirmedCheckoutCode = nativeApplied ? offer.code : null;
          if (s.quantity > 0 && !nativeApplied) {
            await restoreNativeOffer();notice('Your gift could not be applied. Your usual offer is still available; check your bag total.');
          }
          render();safe = true;
        } catch (error) {
          lastSyncError = {name:String(error?.name || 'Error').slice(0,80),message:String(error?.message || 'gift_sync_failed').slice(0,160)};
          nativeApplied = false;confirmedCheckoutCode = null;uiUnavailable = true;render();
          try {await restoreNativeOffer();safe = true;if (!eligible()) expiredCleaned = true;notice('Your gift could not be confirmed. Your usual offer is still available; check your bag total.');}
          catch (_) {notice('We could not confirm your bag total. Please try again before checkout.');}
        }
      } while (queue && !resetting);
      cartNeedsRecovery = !safe;return safe;
    })();
    try {return await syncPromise;} finally {syncPromise = null;noteGiftDiagnostics();}
  }
  async function prepare(add = 1,flash = false) {
    if (resetting || !eligible()) return false;
    if (syncPromise) await syncPromise;
    if (preparePromise) await preparePromise;
    if (resetting || !eligible()) return false;
    preparePromise = (async () => {
      try {
        const signal = AbortSignal.timeout(3500), cart = confirmedCart || await cartGet(signal);
        const offer = selection(shape(cart,add,flash));await setCode(cart,offer.code,signal,false,false);return true;
      } catch (_) {confirmedCart = null;uiUnavailable = true;render();notice('We could not apply your gift right now. Please check the price in your bag.');return false;}
    })();
    try {return await preparePromise;} finally {preparePromise = null;}
  }
  function claim() {
    if (resetting) return;
    if (!saved) {const at = Date.now();saved = {version:2,state:'claim',claimedAt:at,addDeadline:at + 120000,cartDeadline:null};write();}
    rememberContext();
    expire();uiUnavailable = false;render();
  }
  window.SofthourHalloween = {
    prepareAdd:async (pid,formData) => fleeceProduct(pid) ? prepare(Number(formData.get('quantity') || 1),false) : false,
    prepareUpsell:pid => fleeceProduct(pid) ? prepare(1,true) : Promise.resolve(false),active,beginOperation,endOperation,
  };
  document.querySelector('[data-sfhg-open]')?.addEventListener('click',() => {
    if (resetting) return;
    claim();dialog.showModal();dialog.querySelector('[data-sfhg-loading]').hidden = true;
    dialog.querySelector('[data-sfhg-error]').hidden = active();dialog.querySelector('[data-sfhg-success]').hidden = !active();
    render();
    // Prepare the native cart after the user claims; the reveal never waits on a request.
    if (eligible()) sync().catch(() => {});
  });
  document.querySelectorAll('[data-sfhg-close]').forEach(x => x.addEventListener('click',() => dialog.close()));
  async function resetGift() {
    if (!cfg.previewReset || resetting) return;
    resetting = true;clearTimeout(cartDelay);render();
    resetPromise = (async () => {
      try {
        if (preparePromise) await preparePromise;
        if (syncPromise) await syncPromise;
        await restoreNativeOffer();localStorage.removeItem(KEY);saved = null;
        try {const context=JSON.parse(sessionStorage.getItem(cfg.contextKey)||'null');if(context?.arm===cfg.arm&&context?.qa===!!cfg.qa)sessionStorage.removeItem(cfg.contextKey);} catch (_) {}
        // Consume only the reset command so refreshes do not reset the timer again.
        // Keep preview access, attribution parameters and the current anchor intact.
        const params = new URLSearchParams(location.search);
        resetParameters.forEach(key => {if (params.get(key) === 'reset') params.delete(key);});
        const search = params.toString();
        history.replaceState(history.state,'',location.pathname + (search ? '?' + search : '') + location.hash);
        location.reload();
      } catch (_) {resetting = false;render();notice('Impossible de confirmer le panier. Rechargez cette page pour réessayer la réinitialisation.');}
    })();
    try {await resetPromise;} finally {resetPromise = null;}
  }
  dialog?.addEventListener('click',e => {if (e.target === dialog) {const r = dialog.getBoundingClientRect();if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close();}});
  document.addEventListener('variant:update',() => requestAnimationFrame(render));
  document.addEventListener('cart:update',e => {
    if (resetting || e.detail?.sourceId === sourceId) {render();return;}
    const observed = e.detail?.resource;
    confirmedCart = null;
    const completeCart = observed && Array.isArray(observed.items) && Number.isFinite(observed.total_price) ? rememberCart(observed) : null;
    const d = e.detail?.data || {}, added = !d.didError && fleeceProduct(d.productId) && Array.isArray(d.addedItems) && d.addedItems.length > 0;
    // Commit immediately on the actual successful ATC, before any request or reload.
    if (added && eligible() && saved.state === 'claim') {saved.state = 'cart';saved.cartDeadline = Date.now() + 300000;write();}
    render();if (!saved) return;
    clearTimeout(cartDelay);cartDelay = setTimeout(() => sync(false,completeCart),added ? 0 : 180);
  });
  let checkoutBusy = false, checkoutReady = false;
  const checkoutSelector = 'button[name="checkout"],a[href="/checkout"],#checkout';
  async function checkout(e,b) {
    if (!b || resetting || checkoutReady || (!operationCount && !saved) || (!operationCount && !cartNeedsRecovery && !syncPromise && !preparePromise && !eligible() && expiredCleaned)) return;
    e.preventDefault();e.stopImmediatePropagation();if (checkoutBusy) return;checkoutBusy = true;b.setAttribute('aria-busy','true');
    const expectedGift = active();
    let safe = false;
    try {clearTimeout(cartDelay);await waitForOperations();safe = saved ? await sync() : true;} finally {checkoutBusy = false;b.removeAttribute('aria-busy');}
    if (!safe) {notice('We could not confirm your bag total. Please try again before checkout.');return;}
    if(window.SofthourStockAvailability && !await window.SofthourStockAvailability.checkoutAllowed()) return;
    // A successful fallback confirms the ordinary price, not the promised gift.
    // Leave the updated total visible before the customer decides to continue.
    if (expectedGift && (!eligible() || !nativeApplied || !confirmedCheckoutCode)) {
      notice('Your '+(fall?'fall':'Halloween')+' gift could not be confirmed. Please review your updated bag total, then try checkout again.');return;
    }
    if (eligible() && nativeApplied && confirmedCheckoutCode) {
      // Explicitly hand the confirmed code to Shopify's server-side discount
      // route. A normal /cart submit can resume an older checkout without it.
      (window.SofthourStockAB || window.SofthourFallAB || window.SofthourPriceAB || window.SofthourHalloweenAB)?.checkout?.();
      location.assign(root + 'discount/' + encodeURIComponent(confirmedCheckoutCode) + '?redirect=' + encodeURIComponent(root + 'checkout'));
      return;
    }
    const currentButton = b.isConnected ? b : document.querySelector(checkoutSelector);checkoutReady = true;
    try {if (currentButton) currentButton.click();else {(window.SofthourStockAB || window.SofthourFallAB || window.SofthourPriceAB || window.SofthourHalloweenAB)?.checkout?.();location.assign(root + 'checkout');}} finally {checkoutReady = false;}
  }
  document.addEventListener('click',e => checkout(e,e.target.closest?.(checkoutSelector)),true);
  document.addEventListener('submit',e => checkout(e,e.submitter?.matches?.(checkoutSelector) ? e.submitter : null),true);
  document.addEventListener('visibilitychange',() => {if (!document.hidden && saved) sync();});
  window.addEventListener('pageshow',e => {
    if (!e.persisted) return;
    // Back/Forward can restore pre-gift HTML and a stale in-memory claim.
    try {saved = readSaved(localStorage.getItem(KEY));} catch (_) {}
    if (saved) sync(true);
  });
  window.addEventListener('storage',e => {
    if (e.key !== KEY) return;
    saved = readSaved(e.newValue);confirmedCart = null;nativeApplied = false;confirmedCheckoutCode = null;uiUnavailable = false;expiredCleaned = false;render();
    if (saved) sync();else restoreNativeOffer().catch(() => notice('Please check your bag total before checkout.'));
  });
  if (typeof MutationObserver === 'function') {
    const cartStructure = '.cart-drawer__summary,.cart__summary,.sfhg-cart-note';
    const observer = new MutationObserver(records => {
      if (resetting || !active() || saved.state !== 'cart' || !nativeApplied) return;
      const replaced = records.some(r => [...r.addedNodes,...r.removedNodes].some(n =>
        n.nodeType === 1 && (n.matches?.(cartStructure) || n.querySelector?.(cartStructure))));
      if (replaced) {renderCartNote();updateClocks();}
    });
    document.querySelectorAll('cart-drawer-component,main').forEach(root => observer.observe(root,{childList:true,subtree:true}));
  }
  setInterval(tick,1000);render();
  if (launcher && inPage && !urlReset) {
    setTimeout(() => {launcherReady = true;render();},2500);
  }
  if (urlReset) resetGift();
  else if (saved) sync(true); // Reconcile restored HTML; unclaimed visits make no request.
})();
